<template>
  <el-table
    :data="shopCategories"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="id"
      label="#"
      width="50"
      fixed
    />
    <el-table-column
      prop="name"
      label="Név"
      fixed
    />
    <el-table-column
      prop="shops"
      label="Üzletek"
    >
      <template slot-scope="scope">
        <el-tag v-if="scope.row.shops.length" type="primary"> {{ scope.row.shops.length }} üzlet </el-tag>
        <el-tag v-else type="danger">Nincs Üzlet</el-tag>
      </template>
    </el-table-column>
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :shopCategory="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions';

  export default {

    components: {
      Actions
    },

    computed: {
      shopCategories() {
        return this.$store.getters['shopCategory/shopCategories'];
      },

      loading() {
        return this.$store.getters['shopCategory/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('shopCategory/fetchAll');
    },
  };
</script>
